export default __webpack_public_path__ + "static/media/blueCloud.33fd26fb.svg";